<template>
  <div class="page-container">
    <div class="header-wrap">
      <div class="left">
        <a-icon class="icon-left-arrow" type="left" @click="$router.back()" />
        <span class="activity-name" @click="$router.back()" v-if="!isEditActivityName">{{ activityName }}</span>
        <a-input class="edit-input" :placeholder="activityName" v-model="activityName" v-else :maxLength="20" />
        <a-icon class="icon-edit" type="edit" theme="filled" @click="editCourseName" />
      </div>
      <div class="right">
        <a-popover v-model="shareVisible" title="" trigger="click" placement="bottomRight">
          <div class="btn-share">分享活动链接</div>
          <template slot="content">
            <div class="share-content">
              <div class="share-url">
                <span class="url">{{ activityUrl }}</span>
                <span class="btn-copy" @click="doCopy">复制链接</span>
              </div>
              <div class="share-tip">通过“电脑网页”或“手机”打开该链接即可观摩课堂直播</div>
            </div>
          </template>
        </a-popover>
      </div>
    </div>
    <!-- 翻转课列表start -->
    <div class="content-wrap">
      <div class="content-title">翻转课活动目录</div>
      <div class="course-list">
        <draggable
          class="list-group"
          tag="div"
          v-model="spocCourseList"
          :move="onMove"
          @start="handlerStart"
          @end="handlerEnd"
          :group="{ name: 'draggableBox', pull: true, put: true }"
        >
          <div
            class="course-item"
            @click="handleSpocCourseModal({ show: true, option: 'edit', spocCourseItem: item }, $event)"
            v-for="item in spocCourseList"
            :key="item.cardId"
          >
            <i class="icon-close"></i>
            <i class="icon-custom">自定义</i>
            <p class="course-name">{{ item.courseName }}</p>
            <p class="course-teacher">主讲老师：{{ item.userName }}</p>
          </div>
        </draggable>
        <div class="btn-add" @click="handleSpocCourseModal({ show: true, option: 'add' })">
          <p class="text">
            <i class="icon-plus"></i>
            添加一门翻转课
          </p>
        </div>
      </div>
    </div>
    <!-- 翻转课列表end -->
    <AddSpocCourse
      :activityDetail="activityDetail"
      :activityId="activityId"
      :modalData="addSpocCourseModal"
      :courseItem="curCourseItem"
      @updateModalData="handleSpocCourseModal"
      @getActiveDetail="getActiveDetail"
    ></AddSpocCourse>
  </div>
</template>

<script>
import AddSpocCourse from './comp/AddSpocCourse.vue'
import draggable from 'vuedraggable'
export default {
  name: 'ActiveListDetailSpoc',
  components: {
    AddSpocCourse,
    draggable
  },
  data() {
    return {
      activityUrl: '', // 分享链接
      activityId: this.$route.query.id,
      activityDetail: {},
      activityName: '',
      isEditActivityName: false,
      shareVisible: false,
      spocCourseList: [],
      curCourseItem: {},
      addSpocCourseModal: {
        show: false
      },
      isDragging: false
    }
  },
  mounted() {
    this.getActiveDetail()
  },
  methods: {
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element
      const draggedElement = draggedContext.element
      return (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
    },
    handlerStart() {
      this.isDragging = true
    },
    async handlerEnd() {
      this.isDragging = false
      const sortedIdList = this.spocCourseList.map((i) => i.cardId)
      try {
        await this.$http.sortActivityCourse({
          cardIds: sortedIdList.join(',')
        })
      } catch (error) {}
      this.getActiveDetail()
    },
    doCopy() {
      this.$copyText(this.activityUrl || '').then(
        (e) => {
          this.$message.success('复制成功!')
        },
        (e) => {
          this.$message.error('复制失败!')
        }
      )
    },
    // 修改活动名
    async editCourseName() {
      const { isEditActivityName } = this
      if (!isEditActivityName) {
        this.isEditActivityName = true
        return
      }
      if (this.activityName.length > 20) {
        return this.$message.error('活动名称不得大于20个字')
      }
      if (this.activityName.trim().length == 0) {
        return this.$message.error('活动名称不可为空')
      }
      let res = await this.$http.updateActivityInfo({
        activityId: this.activityId,
        activityName: this.activityName
      })
      this.isEditActivityName = false
      if (res.rt.resultStatus == -1 || res.code != 200) {
        return this.$message.error(res.rt.resultMessage || '修改活动名失败！')
      }
      this.getActiveDetail()
    },
    // 获取活动详情
    async getActiveDetail() {
      let res = await this.$http.getActivityLive({
        activityId: this.activityId
      })
      if (res.code !== 200) {
        return this.$message.error(res.msg || '请求活动详情失败！')
      }
      this.activityDetail = res.rt || {}
      // this.activityUrl = `https://www.livecourse.com/teacher/activityList?activityInviteCode=${encodeURIComponent(this.activityDetail.encryptInviteCode || '')}`
      this.activityUrl = `https://zhs-livecourse.zhihuishu.com/teacher/activityList?activityInviteCode=${encodeURIComponent(
        this.activityDetail.encryptInviteCode || ''
      )}`
      this.activityName = this.activityDetail.activityName
      this.spocCourseList = this.activityDetail.aidedTeachCourseInfos || []
    },
    async delSpocCourse() {
      const { curCourseItem } = this
      const res = await this.$http.deleteActivityCourse({
        cardId: curCourseItem.cardId
      })
      if (res.code !== 200) return this.$message.error('删除失败！')
      if (res.rt.resultStatus === 1) {
        this.getActiveDetail()
      } else {
        this.$message.error('删除失败！')
      }
    },
    handleSpocCourseModal(obj = {}, e) {
      const { show, option, spocCourseItem = {} } = obj
      this.curCourseItem = spocCourseItem
      if (e && e.target.className.indexOf('icon-close') >= 0) {
        this.delSpocCourse()
      } else {
        this.addSpocCourseModal = {
          show,
          option,
          modalTitle: option === 'add' ? '添加一门翻转课' : '编辑翻转课'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  color: #1e2228;
  height: 100%;
}
.header-wrap {
  height: 60px;
  padding: 0 16px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  .left {
    color: #1e2228;
    font-size: 14px;
    font-weight: bold;
    display: flex;
    align-items: center;
    .icon-left-arrow {
      padding-right: 10px;
    }
    .activity-name {
      cursor: pointer;
    }
    .edit-input {
      width: 310px;
    }
    .icon-edit {
      margin-left: 10px;
      font-size: 18px;
      &:hover {
        opacity: 0.8;
      }
    }
  }
  .right {
    .btn-share {
      box-sizing: border-box;
      display: inline-block;
      color: #5f60d3;
      border: 1px solid #5f60d3;
      width: 112px;
      height: 38px;
      line-height: 38px;
      font-size: 14px;
      border-radius: 4px;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
    }
  }
}
.content-wrap {
  padding: 14px 16px;
  background: #fff;
  height: calc(100% - 76px);

  .content-title {
    font-size: 14px;
    text-align: left;
    margin-bottom: 14px;
    &::before {
      content: '';
      display: inline-block;
      width: 2px;
      height: 12px;
      background: #5f60d3;
      margin-right: 5px;
      vertical-align: -2px;
    }
  }
  .course-list {
    height: calc(100% - 36px);
    background: #f5f8fa;
    padding: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: scroll;
    .course-item {
      cursor: pointer;
      width: 398px;
      height: 116px;
      padding: 20px 16px 0;
      margin-bottom: 16px;
      font-size: 14px;
      box-sizing: border-box;
      position: relative;
      border-radius: 4px;
      background: #ffffff;
      box-shadow: 0px 2px 6px 0px rgba(31, 40, 100, 0.1);
      text-align: left;
      .icon-close {
        position: absolute;
        left: -10px;
        top: 0;
        width: 20px;
        height: 20px;
        background: url('../../../assets/img/icon-close@2x.png');
        background-size: cover;
        cursor: pointer;
        &:hover {
          opacity: 0.8;
        }
      }
      .icon-custom {
        position: absolute;
        right: 0;
        top: 0;
        color: #fff;
        height: 20px;
        width: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        border-radius: 0 4px 0 4px;
        background: #5f60d3;
      }
      .course-name {
        margin-bottom: 10px;
        word-break: break-word;
        word-wrap: break-word;
      }
      .course-teacher {
        color: #9ca5b1;
      }
    }

    .btn-add {
      width: 398px;
      height: 116px;
      color: #9ca5b1;
      font-size: 16px;
      border-radius: 4px;
      display: flex;
      flex: none;
      justify-content: center;
      align-items: center;
      border: 1px solid #caced7;
      background: #fff;
      cursor: pointer;
      .text {
        text-align: center;
        .icon-plus {
          display: inline-block;
          width: 40px;
          height: 40px;
          margin-right: 16px;
          background: url('../../../assets/img/icon-plus@2x.png') no-repeat;
          background-size: cover;
          vertical-align: -13px;
        }
      }
      &:hover {
        opacity: 0.8;
      }
    }
  }
}
</style>
<style lang="scss">
.share-content {
  padding: 16px;
  width: 360px;
  .share-url {
    font-size: 14px;
    height: 28px;
    line-height: 28px;
    display: flex;
    margin-bottom: 12px;
    .url {
      display: inline-block;
      border: 1px solid #dcdee0;
      width: calc(100% - 64px);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding-left: 5px;
    }
    .btn-copy {
      display: inline-block;
      font-size: 12px;
      background: #5f60d3;
      color: #fff;
      width: 64px;
      height: 28px;
      text-align: center;
      cursor: pointer;
      &:hover {
        opacity: 0.9;
      }
    }
  }
  .share-tip {
    font-size: 12px;
    color: #9fa2b1;
  }
}
</style>
